import {Link} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";

export const ConversationLink = ({projectId, conversationId}) => {
  if (!conversationId) return "-";
  return (
    <Link
      component={RouterLink}
      to={`/project/${projectId}/supervision/${conversationId}`}
      onClick={(e) => e.stopPropagation()}
    >
      #{conversationId}
    </Link>
  )
}
